import { BackgroundWrapper } from "@ui/blocks/DownloadAppBanner/elements/BackgroundWrapper";
import { ImageWithFallBack } from "@motain/web-shared-hub/ui/blocks";

import OFLOGO from "@/assets/images/OneFootballGreen.svg";
import googlePlayImg from "@/assets/images/GooglePlayStoreImg.png";
import appStoreImg from "@/assets/images/AppStoreImg.png";
import { FC } from "react";
import { FontSize } from "@motain/web-shared-hub/types";
import { TextWrapper } from "@ui/blocks/DownloadAppBanner/elements/TextWrapper";
import { ErrorTitle } from "@ui/elements/ErrorTitle";
import { MessageText } from "@ui/blocks/DownloadAppBanner/elements/MessageText";
import { ContentWrapper } from "@ui/blocks/DownloadAppBanner/elements/ContentWrapper";
import { BodyText } from "@motain/web-shared-hub/ui/elements";
import { ImageWrapper } from "@ui/blocks/DownloadAppBanner/elements/ImageWrapper";
import { AppDownloadImageWrapper } from "@ui/blocks/DownloadAppBanner/elements/AppDownloadImageWrapper";
import { ImageDivider } from "@ui/blocks/DownloadAppBanner/elements/ImageDivider";

interface DownloadAppBannerProps {
  title: string;
  message: string;
  appLink?: string;
  getAppText?: string;
  shouldShowDownloadIcons?: boolean;
}

export const DownloadAppBanner: FC<DownloadAppBannerProps> = ({
  title,
  message,
  appLink = "#",
  shouldShowDownloadIcons = false,
  getAppText = "",
}) => {
  return (
    <BackgroundWrapper>
      <ContentWrapper>
        <TextWrapper>
          <ErrorTitle size={FontSize.DrukTitle_3}>{title}</ErrorTitle>
          <MessageText size={FontSize.BodyText_5}>{message}</MessageText>
        </TextWrapper>
        {shouldShowDownloadIcons && (
          <ImageWrapper>
            <ImageWithFallBack width={108} height={108} src={OFLOGO} />
            <ImageDivider style={{ height: 108 }} />
            <AppDownloadImageWrapper
              style={{
                height: 108,
              }}
            >
              <ImageWithFallBack width={102} height={34} src={googlePlayImg} />
              <ImageWithFallBack width={102} height={34} src={appStoreImg} />

              <BodyText
                size={FontSize.BodyText_7}
                as="a"
                href={appLink}
                target="_blank"
                style={{ color: "#4e95ff", textDecoration: "underline" }}
              >
                {getAppText}
              </BodyText>
            </AppDownloadImageWrapper>
          </ImageWrapper>
        )}
      </ContentWrapper>
    </BackgroundWrapper>
  );
};
